/* @flow */

import React from 'react';
import { Card, Input, Button } from 'semantic-ui-react';
import ResourceDimmer from 'shared/components/ResourceDimmer';

type Props = {
  image: EditorialGalleryImage,
  onUpdate: (image: EditorialGalleryImage) => void,
  onDelete: (image: EditorialGalleryImage) => void,
};

const styles = {
  input: {
    margin: '8px',
  },
};

const GalleryImage = ({ image, onUpdate, onDelete }: Props) => {
  const update = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      onUpdate({
        ...image,
        title: event.target.value,
      });
    }
  };

  const remove = () => onDelete(image);

  return (
    <Card key={image.order}>
      <ResourceDimmer resource={image.resource && image.resource.source}>
        <div>
          <Button
            onClick={remove}
            icon="close"
            color="red"
            content="Supprimer"
            labelPosition="right"
          />
        </div>
      </ResourceDimmer>
      <Card.Content extra>
        <Input
          value={image.title || ''}
          onChange={update}
          fluid
          placeholder="Titre"
          style={styles.input}
        />
      </Card.Content>
    </Card>
  );
};

export default GalleryImage;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/gallery/GalleryImage.js